import { snakeCase, toUpper } from 'lodash'
import { failure, success } from '../../utilities/actions'
import type { DateRangeOption, RoundCountItem, ReportCountItem } from './types'

export const REPORT_REVIEW_CHART_DATA_LOAD = 'REPORT_REVIEW_CHART_DATA_LOAD' as const
export const REPORT_REVIEW_CHART_DATA_LOAD_SUCCESS = success(REPORT_REVIEW_CHART_DATA_LOAD)
export const REPORT_REVIEW_CHART_DATA_LOAD_FAILURE = failure(REPORT_REVIEW_CHART_DATA_LOAD)

export const RESULT_ENTRY_CHART_DATA_LOAD = 'RESULT_ENTRY_CHART_DATA_LOAD' as const
export const RESULT_ENTRY_CHART_DATA_LOAD_SUCCESS = success(RESULT_ENTRY_CHART_DATA_LOAD)
export const RESULT_ENTRY_CHART_DATA_LOAD_FAILURE = failure(RESULT_ENTRY_CHART_DATA_LOAD)

export const REPORT_CAPA_CHART_DATA_LOAD = 'REPORT_CAPA_CHART_DATA_LOAD' as const
export const REPORT_CAPA_CHART_DATA_LOAD_SUCCESS = success(REPORT_CAPA_CHART_DATA_LOAD)
export const REPORT_CAPA_CHART_DATA_LOAD_FAILURE = failure(REPORT_CAPA_CHART_DATA_LOAD)

export const loadData = (
  category: 'reportReviewChart' | 'resultEntryChart' | 'reportCapaChart',
  dateRange: DateRangeOption
) => ({
  type: `${toUpper(snakeCase(category))}_DATA_LOAD` as
    | 'REPORT_REVIEW_CHART_DATA_LOAD'
    | 'RESULT_ENTRY_CHART_DATA_LOAD'
    | 'REPORT_CAPA_CHART_DATA_LOAD',
  dateRange
})

// non-exported action creators are purely for type derivation
const resultEntryLoadSuccess = (data: RoundCountItem[]) => ({
  type: RESULT_ENTRY_CHART_DATA_LOAD_SUCCESS,
  data,
})

const resultEntryLoadFailure = (errors: string[]) => ({
  type: RESULT_ENTRY_CHART_DATA_LOAD_FAILURE,
  errors,
})

const reportReviewLoadSuccess = (data: ReportCountItem[]) => ({
  type: REPORT_REVIEW_CHART_DATA_LOAD_SUCCESS,
  data,
})

const reportReviewLoadFailure = (errors: string[]) => ({
  type: REPORT_REVIEW_CHART_DATA_LOAD_FAILURE,
  errors,
})

const reportCapaLoadSuccess = (data: ReportCountItem[]) => ({
  type: REPORT_CAPA_CHART_DATA_LOAD_SUCCESS,
  data,
})

const reportCapaLoadFailure = (errors: string[]) => ({
  type: REPORT_CAPA_CHART_DATA_LOAD_FAILURE,
  errors,
})

export type DashboardAction =
  | ReturnType<typeof loadData>
  | ReturnType<typeof resultEntryLoadSuccess>
  | ReturnType<typeof resultEntryLoadFailure>
  | ReturnType<typeof reportReviewLoadSuccess>
  | ReturnType<typeof reportReviewLoadFailure>
  | ReturnType<typeof reportCapaLoadSuccess>
  | ReturnType<typeof reportCapaLoadFailure>
